import React from "react";
import PropTypes from "prop-types";

const shapes = {
  square: "rounded-[0px]",
};
const variants = {
  outline:{
    white_A700:"border-white-a700 border border-solid text-white-a700"
  },
  fill: {
    pink_A200:"bg-pink-a200 text-white-a700",
    white_A700: "bg-white-a700 text-black-900_01",
    indigo_A700: "bg-indigo-a700 text-white-a700",
    green_A700: "bg-green-a700 text-black-900_01",
    red_500:"bg-red-500 text-white-a700"
  
  },
};
const sizes = {
  xs: "h-[52px] px-[34px] text-[20px]",
  xs1: "h-[26px] px-[24px] text-[16px]",
};

const Button = ({
  children,
  className = "",
  leftIcon,
  rightIcon,
  shape,
  variant = "fill",
  size = "xs",
  color = "white_A700",
  ...restProps
}) => {
  return (
    <button
      className={`${className} flex flex-row items-center justify-center self-stretch sm:px-5 text-center cursor-pointer whitespace-nowrap font-medium ${shape && shapes[shape]} ${size && sizes[size]} ${variant && variants[variant]?.[color]}`}
      {...restProps}
    >
      {!!leftIcon && leftIcon}
      {children}
      {!!rightIcon && rightIcon}
    </button>
  );
};

Button.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  leftIcon: PropTypes.node,
  rightIcon: PropTypes.node,
  shape: PropTypes.oneOf(["square"]),
  size: PropTypes.oneOf(["xs"]),
  variant: PropTypes.oneOf(["fill"]),
  color: PropTypes.oneOf(["white_A700", "indigo_A700"]),
};

export { Button };
